import React from 'react'
import { observer,inject } from 'mobx-react'

import { withLayoutAdmin } from '../../utils/hoc'
import T from 'i18n-react'
import Grid from 'material-ui/Grid'
import Card, { CardContent } from 'material-ui/Card'
import TextField from 'material-ui/TextField'
import Input, { InputAdornment } from 'material-ui/Input'
import Typography from 'material-ui/Typography'
import { CirclePicker } from 'react-color'
import Popover from 'material-ui/Popover'
import Button from 'material-ui/Button'
import Switch from 'material-ui/Switch'
import { yellow,red } from 'material-ui/colors'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'


@inject('admin','adminui','messenger') @observer
class Welcomepagesettings extends React.Component {
  componentWillMount () {
    this.props.admin.getWPSettings()
  }

  render () {
    const wpSettings = this.props.admin.wpSettings, xs = 12, sm = 6, md = 4, lg = 4,
          ui = this.props.adminui, classes = this.props.classes

    return (
      <Grid container direction="column" justify="center" alignItems="center" spacing={Number(0)}>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card className="admin-settings-card">
        <CardContent>
         <Typography type="headline" component="h2"> {T.translate("admin.wpSettings.title")} </Typography>
         <Typography type="caption" component="p">
          {T.translate("admin.wpSettings.titleDescription")}: <a href={window.location.origin} target="_new_tab">{window.location.origin}</a>
         </Typography>


          <div className={classes.switcherContainer}>
           <Typography type="caption" className={classes.switcherLabel}>
            {wpSettings.enabled ? T.translate("admin.wpSettings.enabled") : T.translate("admin.wpSettings.disabled")}
           </Typography>
           <Switch
            checked={wpSettings.enabled?true:false}
            onChange={this.saveEnabled}
            aria-label="wpsettings-enabled"
            className={classes.switcher}
            classes={{
             checked: classes.checked
            }}
           />
           <div className={classes.clear} />
          </div>

        </CardContent>
       </Card>
      </Grid>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card className="admin-settings-card">
        <CardContent>
         <Typography type="headline" component="h2"> {T.translate("admin.wpSettings.setLogo")} </Typography>
         {wpSettings.logo !== "" && <img className={classes.logo} src={wpSettings.logo} alt="" />}
         <TextField
          id="wp-logo"
          value={wpSettings.logo}
          onChange={this.setLogo}
          onBlur={this.saveLogo}
          fullWidth
         />
        </CardContent>
       </Card>
      </Grid>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card className="admin-settings-card">
        <CardContent>
         <Typography type="headline" component="h2"> {T.translate("admin.wpSettings.setTitle")} </Typography>
         <TextField
          id="wp-title"
          value={wpSettings.title}
          onChange={this.setTitle}
          onBlur={this.saveTitle}
          fullWidth
         />
        </CardContent>
       </Card>
      </Grid>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card>
        <CardContent>
         <Typography type="headline" component="h2"> {T.translate("admin.wpSettings.setSubtitle")} </Typography>
         <TextField
          id="wp-subtitle"
          value={wpSettings.subtitle}
          onChange={this.setSubtitle}
          onBlur={this.saveSubtitle}
          fullWidth
         />
        </CardContent>
       </Card>
      </Grid>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card>
        <CardContent>
         <Typography type="headline" component="h2"> {T.translate("admin.wpSettings.setBackgroundImage")} </Typography>
         {wpSettings.backgroundImage !== "" && <img className={classes.logo} src={wpSettings.backgroundImage} alt="" />}
         <TextField
          id="wp-backgroundimage"
          value={wpSettings.backgroundImage}
          onChange={this.setBackgroundImage}
          onBlur={this.saveBackgroundImage}
          fullWidth
         />
        </CardContent>
       </Card>
      </Grid>

      <Grid item xs={xs} sm={sm} md={md} lg={lg} className="admin-settings-card">
       <Card>
        <CardContent>
         <Typography type="headline" component="h2"> {T.translate("admin.wpSettings.setDescription")} </Typography>
         <TextField
          id="wp-description"
          value={wpSettings.description}
          onChange={this.setDescription}
          onBlur={this.saveDescription}
          multiline
          rows={8}
          fullWidth
         />
        </CardContent>
       </Card>
      </Grid>

     </Grid>
    )
  }

  saveEnabled = (e,checked) => {
   this.props.admin.wpSettings.setEnabled(checked, (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setLogo = (e) => {
    this.props.admin.wpSettings.setLogo(e.target.value)
  }
  saveLogo = () => {
   this.props.admin.wpSettings.saveLogo( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setTitle = (e) => {
    this.props.admin.wpSettings.setTitle(e.target.value)
  }
  saveTitle = () => {
   this.props.admin.wpSettings.saveTitle( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setSubtitle = (e) => {
    this.props.admin.wpSettings.setSubtitle(e.target.value)
  }
  saveSubtitle = () => {
   this.props.admin.wpSettings.saveSubtitle( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setBackgroundImage = (e) => {
    this.props.admin.wpSettings.setBackgroundImage(e.target.value)
  }
  saveBackgroundImage = () => {
   this.props.admin.wpSettings.saveBackgroundImage( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }
  setDescription = (e) => {
    this.props.admin.wpSettings.setDescription(e.target.value)
  }
  saveDescription = () => {
   this.props.admin.wpSettings.saveDescription( (res) => {
     if (res.success) {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_UPDATED)
     }
   })
  }

}


const styles = theme => ({
  logo: {
    width:'100%'
  },
  switcher:{
    float:'right'
  },
  switcherLabel:{
    float:'left',
    paddingTop:18
  },
  switcherContainer:{
    marginTop:20,
    borderTop:'1px solid #eee'
  },
  clear:{
    clear:'both'
  },
  checked: {
    color: theme.palette.secondary,
    '& + $bar': {
      backgroundColor: theme.palette.secondary,
    },
  },
})


Welcomepagesettings.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(withLayoutAdmin(Welcomepagesettings))



// WEBPACK FOOTER //
// ./src/components/admin/welcomepagesettings.js